import { REPORT_BILLING_RESULTS } from '@/data/actions/modules/financial';

export default [
  {
    path: '/financial/billing-reports',
    component: () => import(/* webpackChunkName: "billing-reports" */ './components/Main.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
      permission: REPORT_BILLING_RESULTS,
    },
  },
];
